import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/* eslint-disable */
// eslint is complaining about not having a control wrapped within label because Select is not recognised as <select/>
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from '../select/Select';

var getSelected = function getSelected(v, options) {
  return options.find(function (option) {
    return String(v) === String(option.value);
  });
};

function BadgeSelect(_ref) {
  var classNames = _ref.classNames,
      selectOptions = _ref.selectOptions,
      value = _ref.value,
      onChange = _ref.onChange;

  var _useState = useState(selectOptions[0].label),
      _useState2 = _slicedToArray(_useState, 2),
      label = _useState2[0],
      setLabel = _useState2[1];

  var selected = getSelected(value, selectOptions);
  var badgeLabel = selected ? selected.label : label;

  var onSelectChange = function onSelectChange(e) {
    if (!selected) {
      var selectedOption = getSelected(e.target.value, selectOptions);
      setLabel(selectedOption.label);
    }

    onChange(e);
  };

  return /*#__PURE__*/React.createElement("label", {
    className: classNames
  }, badgeLabel, /*#__PURE__*/React.createElement(Select, {
    options: selectOptions,
    value: value,
    className: "tds-badge--select",
    onChange: onSelectChange
  }));
}

BadgeSelect.displayName = "BadgeSelect";
BadgeSelect.propTypes = {
  classNames: PropTypes.string,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string
  })).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired
};
BadgeSelect.defaultProps = {
  classNames: '',
  value: undefined
};
export default BadgeSelect;